// MST
import { types } from 'mobx-state-tree'

// Types
const { optional, model, maybeNull, array, string, number } = types

export const withHelper_assessmentAssessorModel = model('AssessmentAssessor').props({
  id: maybeNull(number),
  name: maybeNull(string),
})

export const AssessmentScheduleTechnicalModel = model('AssessmentScheduleTechnical').props({
  date: maybeNull(string),
  tuk: maybeNull(
    optional(
      model('Tuk').props({
        type: maybeNull(string),
        name: maybeNull(string),
      }),
      {},
    ),
  ),
})

export const withHelper_assessmentScheduleModel = model('AssessmentScheduleModel').props({
  assessors: optional(array(withHelper_assessmentAssessorModel), []),
  technicalBriefing: maybeNull(optional(AssessmentScheduleTechnicalModel, {})),
  preAssessment: maybeNull(optional(AssessmentScheduleTechnicalModel, {})),
  assessment: maybeNull(optional(AssessmentScheduleTechnicalModel, {})),
})
